import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["boxShadow", "label", "index", "active", "completed", "disabled", "onClick", "href", "data-test"];
import React from 'react';
import PropTypes from 'prop-types';
import { TickIcon } from '@sainsburys-tech/bolt-icons';
import * as Styled from './ProgressTracker.styles';

var ProgressTrackerStep = function ProgressTrackerStep(_ref) {
  var boxShadow = _ref.boxShadow,
      label = _ref.label,
      index = _ref.index,
      active = _ref.active,
      completed = _ref.completed,
      disabled = _ref.disabled,
      _onClick = _ref.onClick,
      href = _ref.href,
      dataTest = _ref['data-test'],
      props = _objectWithoutProperties(_ref, _excluded);

  var asElement = 'span';

  if (href || href === '') {
    asElement = 'a';
  } else if (_onClick) {
    asElement = 'button';
  }

  return /*#__PURE__*/React.createElement(Styled.Step, _extends({
    onClick: function onClick(e) {
      return !active && _onClick && _onClick(e, index);
    },
    href: href
  }, props, {
    "data-test": "".concat(dataTest, "-step-").concat(index),
    disabled: disabled,
    as: asElement
  }), /*#__PURE__*/React.createElement(Styled.Marker, {
    "data-test": "".concat(dataTest, "-step-").concat(index, "-icon"),
    active: active,
    boxShadow: boxShadow,
    completed: completed,
    disabled: disabled
  }, completed ? /*#__PURE__*/React.createElement(TickIcon, {
    width: "1.2rem",
    height: "1.2rem"
  }) : index + 1), /*#__PURE__*/React.createElement(Styled.Label, {
    "data-test": "".concat(dataTest, "-step-").concat(index, "-label"),
    active: active,
    disabled: disabled
  }, label));
};

ProgressTrackerStep.displayName = 'ProgressTrackerStep';
ProgressTrackerStep.propTypes = {
  /**
   * Required label for the step that shows as a descriptor under the Step icon
   */
  label: PropTypes.string.isRequired,

  /**
   * Required prop to track the index of the Step in the order of steps
   */
  index: PropTypes.number.isRequired,

  /**
   * Toggle whether the step is active or not
   */
  active: PropTypes.bool,

  /**
   * Toggle whether the step has been completed
   */
  completed: PropTypes.bool,

  /**
   * Toggle whether the step is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Prop to pass through onClick events when step is clicked
   */
  onClick: PropTypes.func,

  /**
   * Prop to pass through boxShadow color for the Step
   */
  boxShadow: PropTypes.string,

  /**
   * Prop to pass through href for when step is clicked
   */
  href: PropTypes.string,

  /**
   * Specify an optional data-test attribute to be added to your Button for e2e testing
   */
  'data-test': PropTypes.string
};
ProgressTrackerStep.defaultProps = {
  boxShadow: '',
  label: '',
  index: 0,
  onClick: null,
  href: null,
  disabled: false,
  completed: false,
  active: false,
  'data-test': 'component-progress-tracker'
};
export default ProgressTrackerStep;